import ModalLogin from './modalLogin';

export default ModalLogin;